(ns frontend.view.modals.folder-selection-modal.view
  (:require
   [common.entity :as entity]
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.view.modals.folder-selection-modal.event :as event]
   [frontend.view.modals.folder-selection-modal.sub :as sub]
   [re-frame.core :as rf]
   [ui.color :as c]
   [ui.components.modal.view :as modal]
   [ui.editors.data-input :as data-input]))

(def modal-key ::modal-key)

(defn folder-selector
  [folder-names]
  (let [selected-folder @(rf/subscribe [::sub/selected-folder])
        folder-options @(rf/subscribe [::sub/folder-options])]
    (js/console.log "Folder options " folder-options " > " folder-names)
    [:div
     [:label
      {:class "font-bold"}
      (loc/tr :move-to-folder)]
     [data-input/view
      {:editor-type :editor.type/select
       :value       (->> folder-options
                         (cu/filter-by :value selected-folder)
                         (first))
       :options     folder-options
       :on-change   (fn [o]
                      (rf/dispatch [::event/set-selected-folder o]))}]]))

(defn view
  [{:keys [close-modal! props _shown? _topmost?]}]
  (let [{:keys [entity folder-names success-callback]} props
        on-close! (fn []
                    (rf/dispatch [::event/clear])
                    (when (fn? success-callback)
                      (success-callback))
                    (close-modal!))]
    (rf/dispatch [::event/init entity folder-names])
    (fn [{:keys [shown? close-modal! props topmost?]}]
      (let [{:keys [entity]} props
            changes? @(rf/subscribe [::sub/changes?])]
        [modal/view
         {:visible?      (and shown? topmost?)
          :hide!         close-modal!
          :backdrop      "static"
          :close-button? true}
         (loc/tr :manage-folders-for [(entity/display-string entity)])
         [folder-selector folder-names]
         [:<>
          [modal/left-cancel-only close-modal! nil]
          [modal/right-single-button
           ::c/primary
           (not changes?)
           #(rf/dispatch [::event/save! entity on-close!])
           (loc/tr :save)
           nil]]]))))
